import { useCallback } from 'react';

export const useOnOff = (setter: React.Dispatch<React.SetStateAction<boolean>>) => {
  const on = useCallback(() => setter(true), [setter]);
  const off = useCallback(() => setter(false), [setter]);

  return [on, off] as const;
};
